// extracted by mini-css-extract-plugin
module.exports = {"Grid":"OnDemand_Grid__1m88M"};